import React from "react";
import { Box, Typography, BoxProps } from "@mui/material";
import AppCircularProgress from "../components/common/AppCircularProgress";
import PageError from "../components/common/PageError";

interface CardGridContainerProps extends BoxProps {
  loading: boolean;
  error: string | null;
  emptyMessage?: string;
  itemCount: number;
  onRetry: () => void;
  children: React.ReactNode;
}

const CardGridContainer: React.FC<CardGridContainerProps> = ({
  loading,
  error,
  emptyMessage = "No records found",
  itemCount,
  onRetry,
  children,
  sx,
  ...rest
}) => {
  if (loading) {
    return <AppCircularProgress />;
  }

  if (error) {
    return <PageError error={error} onRetry={onRetry} />;
  }

  if (itemCount === 0) {
    return (
      <Box sx={{ textAlign: "center", py: 8 }}>
        <Typography color="text.secondary">{emptyMessage}</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          sm: "repeat(2, 1fr)",
          md: "repeat(3, 1fr)",
          lg: "repeat(4, 1fr)",
        },
        gap: 3,
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default CardGridContainer;
